import { doesToolSupportsPersonaForMode } from 'src/data/utils';
import { createStateSelectorHook } from 'src/lib/sweetState';

import { useIsGenerating } from '../../services';
import { LocalStore } from '../../store';

const useLocalState = createStateSelectorHook(LocalStore, ['generationTool', 'selectedModeId']);

export const useIsDisabled = () => {
  const { generationTool, selectedModeId } = useLocalState();
  const generating = useIsGenerating();

  if (generating) {
    return true;
  }

  return !doesToolSupportsPersonaForMode({
    generationTool,
    suggestionMode: selectedModeId,
  });
};
